import { subscribe } from './event-logger';
import { FACEBOOK_EVENT_TYPES } from './event-types';

const facebookTracker = {
    track(event) {
        window.fbq?.('track', event);
    }
}

subscribe((eventType) => {
    if (FACEBOOK_EVENT_TYPES.hasOwnProperty(eventType)) {
        facebookTracker.track(FACEBOOK_EVENT_TYPES[eventType]);
    }
});

export {
    facebookTracker
}
